export const CompanyLogo = (
  <svg viewBox="0 0 673.08 113.39" height="100px">
    <g id="logo_service_backstage_rgb">
      <g
        id="logo_service_backstage_rgb-2"
        data-name="logo_service_backstage_rgb"
      >
        <path
          fill="#1e5a96"
          d="M96.78,16.6c-22.14-22.14-58.04-22.14-80.18,0-22.14,22.14-22.14,58.04,0,80.18,22.14,22.14,58.04,22.14,80.18,0,22.14-22.14,22.14-58.03,0-80.18ZM92.41,36.18c-1.85,5.52-7.79,22.07-7.79,22.07-1.99,5.39-13.62,5.35-29.41,5.39,0,0,10.2-1.44,13.15-7.14,2.95-5.69,6.42-17.23,6.42-17.23-15.71,0-17.11,5.5-17.11,5.5,0,0-9.93,27.77-13.47,38.01-27.51,0-23.12-13.59-23.12-13.59l13.76-38.61h27.88l-1.86,5.56s2.27-5.56,17.64-5.56c0,0,15.75.07,13.9,5.59Z"
        />
        <g>
          <path
            fill="#1e5a96"
            d="M146.14,67.85v14.25h-9.68v-41.58h16.88c4.93,0,8.84,1.26,11.74,3.78,2.9,2.52,4.34,5.82,4.34,9.9s-1.45,7.39-4.34,9.9c-2.89,2.5-6.81,3.75-11.74,3.75h-7.2ZM146.14,60.43h7.2c2.09,0,3.69-.57,4.78-1.73,1.09-1.15,1.64-2.63,1.64-4.44s-.55-3.36-1.64-4.54c-1.09-1.18-2.69-1.77-4.78-1.77h-7.2v12.48Z"
          />
          <path
            fill="#1e5a96"
            d="M207.6,40.52v27.25c0,4.74-1.58,8.42-4.73,11.03-3.15,2.61-7.28,3.91-12.38,3.91s-9.32-1.3-12.48-3.91c-3.16-2.61-4.74-6.28-4.74-11.03v-27.25h9.68v27.25c0,2.55.66,4.44,1.97,5.67,1.31,1.23,3.17,1.84,5.57,1.84s4.21-.61,5.5-1.83c1.29-1.22,1.93-3.11,1.93-5.68v-27.25h9.68Z"
          />
          <path
            fill="#1e5a96"
            d="M223.29,74.68h18.94v7.42h-30.82v-4.34l18.59-29.82h-18.68v-7.43h30.64v4.17l-18.68,29.99Z"
          />
          <path
            fill="#1e5a96"
            d="M257.12,74.68h18.93v7.42h-30.81v-4.34l18.59-29.82h-18.68v-7.43h30.64v4.17l-18.68,29.99Z"
          />
          <path
            fill="#1e5a96"
            d="M289.36,74.68h17.91v7.42h-27.59v-41.58h9.68v34.16Z"
          />
          <path
            fill="#1e5a96"
            d="M336.61,64.31h-16.31v10.37h19.22v7.42h-28.9v-41.58h28.96v7.43h-19.28v8.94h16.31v7.43Z"
          />
        </g>
        <g>
          <path
            fill="#3fa8e0"
            d="M361.99,82.18v-41.6h13.83c4.61,0,8.21.95,10.8,2.84,2.59,1.9,3.88,4.73,3.88,8.5,0,1.88-.54,3.57-1.63,5.06-1.08,1.49-2.59,2.59-4.51,3.31,2.48.55,4.38,1.74,5.71,3.57,1.33,1.83,2,3.95,2,6.37,0,3.91-1.28,6.87-3.83,8.9-2.55,2.03-6.08,3.04-10.57,3.04h-15.69ZM368.93,58.1h7.66c2.15,0,3.85-.51,5.1-1.53s1.87-2.46,1.87-4.33c0-2.06-.66-3.59-1.97-4.59-1.31-1-3.24-1.5-5.77-1.5h-6.89v11.95ZM368.93,63.27v13.34h8.74c2.4,0,4.25-.55,5.54-1.64,1.29-1.09,1.94-2.68,1.94-4.75,0-2.21-.54-3.92-1.63-5.13s-2.78-1.82-5.09-1.82h-9.52Z"
          />
          <path
            fill="#3fa8e0"
            d="M420.91,72.47h-16.29l-3.31,9.71h-7.03l15.29-41.6h6.57l15.12,41.6h-7.06l-3.29-9.71ZM406.62,66.67h12.31l-6.03-17.77h-.17l-6.12,17.77Z"
          />
          <path
            fill="#3fa8e0"
            d="M464.61,68.38l.06.17c.08,4.21-1.29,7.63-4.1,10.27s-6.62,3.96-11.42,3.96-8.8-1.63-11.84-4.9c-3.04-3.27-4.56-7.44-4.56-12.53v-7.92c0-5.07,1.5-9.24,4.5-12.53s6.9-4.93,11.7-4.93,8.79,1.29,11.62,3.87c2.83,2.58,4.21,6.05,4.13,10.41l-.06.17h-6.71c0-2.8-.76-4.98-2.27-6.54-1.52-1.56-3.75-2.34-6.7-2.34s-5.09,1.12-6.76,3.37-2.5,5.06-2.5,8.45v7.96c0,3.43.85,6.26,2.56,8.51,1.71,2.25,4.01,3.37,6.9,3.37s5.06-.77,6.54-2.31c1.48-1.54,2.23-3.71,2.23-6.52h6.69Z"
          />
          <path
            fill="#3fa8e0"
            d="M482.12,64.18h-4.8v18h-6.94v-41.6h6.94v17.63h3.97l13.06-17.63h8.23l-15.14,19.86,16.31,21.75h-8.49l-13.14-18Z"
          />
          <path
            fill="#3fa8e0"
            d="M528.7,71.47c0-1.73-.64-3.14-1.93-4.24-1.29-1.1-3.56-2.09-6.81-2.96-4.65-1.22-8.23-2.83-10.73-4.84-2.51-2.01-3.76-4.64-3.76-7.9s1.39-6.12,4.16-8.29,6.35-3.26,10.73-3.26,8.24,1.23,11.02,3.7,4.11,5.42,4.02,8.87l-.06.17h-6.66c0-2.13-.72-3.86-2.17-5.19-1.45-1.32-3.52-1.99-6.2-1.99-2.53,0-4.48.55-5.84,1.65-1.36,1.1-2.04,2.53-2.04,4.28,0,1.58.74,2.89,2.21,3.94s3.92,2.03,7.33,2.96c4.47,1.2,7.88,2.86,10.2,4.97,2.32,2.11,3.49,4.81,3.49,8.09,0,3.47-1.38,6.22-4.16,8.27-2.77,2.05-6.42,3.07-10.93,3.07s-8.15-1.16-11.43-3.47c-3.28-2.31-4.87-5.47-4.77-9.47l.06-.17h6.69c0,2.53.88,4.42,2.63,5.67s4.03,1.87,6.83,1.87c2.57,0,4.57-.52,6-1.55,1.43-1.03,2.14-2.43,2.14-4.2Z"
          />
          <path
            fill="#3fa8e0"
            d="M570.86,46.15h-12.57v36.03h-6.94v-36.03h-12.57v-5.57h32.09v5.57Z"
          />
          <path
            fill="#3fa8e0"
            d="M593.62,72.47h-16.29l-3.31,9.71h-7.03l15.29-41.6h6.57l15.12,41.6h-7.06l-3.29-9.71ZM579.34,66.67h12.32l-6.03-17.77h-.17l-6.12,17.77Z"
          />
          <path
            fill="#3fa8e0"
            d="M637.93,76.56c-1.11,1.58-2.92,3.01-5.44,4.3-2.52,1.29-5.77,1.93-9.73,1.93-5.01,0-9.13-1.59-12.37-4.76s-4.86-7.27-4.86-12.3v-8.69c0-5.03,1.53-9.13,4.59-12.3s7.01-4.76,11.84-4.76,8.7,1.21,11.42,3.62,4.1,5.55,4.16,9.42l-.06.17h-6.57c-.15-2.29-.97-4.13-2.44-5.53-1.48-1.4-3.61-2.1-6.41-2.1s-5.2,1.08-6.96,3.23c-1.76,2.15-2.64,4.88-2.64,8.19v8.74c0,3.35.96,6.1,2.87,8.26s4.39,3.24,7.44,3.24c2.17,0,3.93-.25,5.29-.75,1.35-.5,2.33-1.1,2.94-1.78v-8.44h-8.26v-5.2h15.2v15.52Z"
          />
          <path
            fill="#3fa8e0"
            d="M670.17,63.47h-18.2v13.14h21.12v5.57h-28.06v-41.6h27.86v5.57h-20.92v11.74h18.2v5.57Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
